module.exports = __webpack_public_path__ + "img/setting_btn.c6ba5a24.png";